"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInventoryOnHand = void 0;
const shared_1 = require("@getgreenline/shared");
const inventory_1 = require("../models/inventory");
const getInventoryOnHand = (companyId, options) => __awaiter(void 0, void 0, void 0, function* () {
    const params = yield (0, shared_1.plainToClassWithValidation)(inventory_1.InventoryOnHandFilter, options.filter);
    const headers = options.responseType === 'csv' ? { Accept: 'text/csv' } : undefined;
    const response = yield shared_1.axios.get(`api/v1/company/${companyId}/reports/v2/inventory-on-hand`, { params, headers });
    return response.data;
});
exports.getInventoryOnHand = getInventoryOnHand;
//# sourceMappingURL=inventory.js.map